const mobile = '17366352936'

export default {
  mobile
}
